import { render, staticRenderFns } from "./btn-primary2.vue?vue&type=template&id=3970beeb&scoped=true"
import script from "./btn-primary2.vue?vue&type=script&lang=js"
export * from "./btn-primary2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3970beeb",
  null
  
)

export default component.exports